import React, { useState, useEffect } from 'react';
import { Grid, Typography, Box } from '@mui/material';
import Layout from '../components/Layout/Layout';
import StatsCards from '../components/Dashboard/StatsCards';
import RecentActivity from '../components/Dashboard/RecentActivity';
import { WorkOrdersChart, WorkOrdersPieChart } from '../components/Dashboard/WorkOrdersChart';
import { useAuth } from '../hooks/useAuth';
import axios from '../api/axiosConfig';

const Dashboard = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardStats();
  }, []);

  const fetchDashboardStats = async () => {
    try {
      const { data } = await axios.get('/dashboard/stats');
      setStats(data);
    } catch (error) {
      console.error('Error fetching dashboard stats:', error);
      // Set default stats if API fails
      setStats({
        totalVehicles: 156,
        activeDevices: 234,
        workOrders: { total: 89, completed: 45, inProgress: 23, pending: 12 },
        clients: { total: 34 },
        recentActivities: [],
        chartData: [
          { month: 'Jan', workOrders: 45 },
          { month: 'Feb', workOrders: 52 },
          { month: 'Mar', workOrders: 48 },
          { month: 'Apr', workOrders: 61 },
          { month: 'May', workOrders: 55 },
          { month: 'Jun', workOrders: 67 },
        ]
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" gutterBottom fontWeight={600}>
          Dashboard
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Welcome back, {user?.fullName}! Here's what's happening with your fleet today.
        </Typography>
      </Box>

      <StatsCards stats={stats} loading={loading} />

      <Grid container spacing={3} sx={{ mt: 1 }}>
        <Grid item xs={12} md={8}>
          <WorkOrdersChart data={stats?.chartData} />
        </Grid>
        <Grid item xs={12} md={4}>
          <WorkOrdersPieChart data={stats} />
        </Grid>
        <Grid item xs={12}>
          <RecentActivity activities={stats?.recentActivities} loading={loading} />
        </Grid>
      </Grid>
    </Layout>
  );
};

export default Dashboard;